import User from '@/models/User'
import Avatar from '@/models/Avatar'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    businessAdminDetails: null
  },

  mutations: {
    setBusinessAdminList(state, admins) {
      each(admins, admin => {
        const exist = find(state.list, { id: admin.id })
        if (!exist) {
          state.list.push(new User(admin))
        }
      })
    },

    clearBusinessAdminList(state) {
      state.list = []
    },

    setBusinessAdminListMeta(state, meta) {
      state.listMeta = meta
    },

    setBusinessAdminDetails(state, admin) {
      if (admin instanceof User) {
        state.businessAdminDetails = admin
      } else {
        state.businessAdminDetails = new User(admin)
      }
    },

    setSelectedBusinessAdminAvatar(state, avatar) {
      if (avatar instanceof Avatar) {
        state.businessAdminDetails.avatar = avatar
      } else {
        state.businessAdminDetails.avatar = new Avatar(avatar)
      }
    },

    clearBusinessAdminDetails(state) {
      state.businessAdminDetails = null
    },

    businessAdminAvatarRemoved(state) {
      state.businessAdminDetails.avatar = null
    }
  },

  actions: {
    async getBusinessAdmins({ commit }, params) {
      const query = User.page(params.page || 1)
        .include('avatar')
        .where('user_type', 'business_admin')

      if (params.search) {
        query.where('search', params.search)
      }

      if (params.searchDate) {
        query.where('searchDate', params.searchDate)
      }

      if (params.sort) {
        query.orderBy(params.sort)
      }

      const res = await query.params({ limit: 20 }).get()

      commit('setBusinessAdminList', res.data)
      commit('setBusinessAdminListMeta', res.meta)
    },

    async getBusinessAdminDetails({ commit }, id) {
      const { data } = await Api.get(`users/${id}`)
      commit('setBusinessAdminDetails', data.data)
    },

    async changeAvatar({ commit }, formData) {
      const { data } = await Api.post(
        `users/${formData.get('user_id')}/avatar`,
        formData
      )
      commit('setSelectedBusinessAdminAvatar', data.data)
    },

    async updateBusinessAdmin({ commit }, formData) {
      const { data } = await Api.put(`users/${formData.id}`, formData)
      commit('setBusinessAdminDetails', data.data)
    },

    async blockBusinessAdmin({ commit }, { id, action }) {
      const { data } = await Api.post(`admin/users/${id}/${action}`)
      commit('setBusinessAdminDetails', data.data)
    },

    async exportToExcel() {
      const file = await Api.get('/users/business-admin/export', {
        responseType: 'blob'
      })
      return file
    }
  }
}
